import {
  GetDealGeneralInfo,
  GetDealGeneralInfoVariables,
} from 'features/deals/dealCards/gql/__generated__/GetDealGeneralInfo';
import { GET_DEAL_GENERAL_INFO_QUERY } from 'features/deals/dealCards/gql/dealDetailsQueries';

import { useQuery } from '@apollo/client';

import { GetUserCompany } from 'query/__generated__/GetUserCompany';
import { GET_USER_COMPANY } from 'query/company';

/**
 * Hook to get deal context including listing_id (as offering_id) and buyer_company_id
 * This is used for carve operations that require these parameters for loan service integration
 */
export const useDealContext = (dealId: string) => {
  const {
    data: dealData,
    loading: dealLoading,
    error: dealError,
  } = useQuery<GetDealGeneralInfo, GetDealGeneralInfoVariables>(GET_DEAL_GENERAL_INFO_QUERY, {
    variables: { id: dealId },
    fetchPolicy: 'cache-first', // Use cache since this data doesn't change frequently
  });

  const {
    data: userData,
    loading: userLoading,
    error: userError,
  } = useQuery<GetUserCompany>(GET_USER_COMPANY, {
    fetchPolicy: 'cache-first',
  });

  const deal = dealData?.deal;

  // For now, we use listing_id as offering_id as specified by the user
  const offeringId = deal?.listing?.id;

  // Get buyer company ID from the current user's company
  // This assumes the current user is the buyer (which should be validated by the backend)
  const buyerCompanyId = userData?.user?.company?.id;

  return {
    offeringId,
    buyerCompanyId,
    loading: dealLoading || userLoading,
    error: dealError || userError,
    deal,
  };
};
